import React, { useEffect, useState } from "react";
import styled from "styled-components";
import {
  replaceCommas,
  returnOptionText,
  textSubStr,
} from "../hooks/basicFunc";
import NoHistory from "./NoHistory";

const PointHistory = (props) => {
  const { data } = props;

  return (
    <>
      {Object.keys(data).length == 0 ? (
        <NoHistory />
      ) : (
        <Table>
          <thead>
            <tr>
              <th>서비스</th>
              <th>거래일시</th>
              <th>구분</th>
              <th>포인트</th>
            </tr>
          </thead>
          <tbody>
            {data.length > 0 &&
              data.map((li, index) =>
                li.logs.map((list, index) => (
                  <tr key={index}>
                    <td>{list.service}</td>
                    <td className="date">
                      {textSubStr(list.time)[0]}

                      <br />
                      {textSubStr(list.time)[1]}
                    </td>
                    <td>{list.type}</td>
                    <td>
                      {list.mup > 0 &&
                      (list.type == "사용" || list.type == "적립취소")
                        ? "-" + replaceCommas(list.mup)
                        : "+" + replaceCommas(list.mup)}
                      p
                    </td>
                  </tr>
                ))
              )}
            {/* {data.count > 0 &&
              data.logs.map((list, index) => (
                <tr key={index}>
                  <td>{list.service}</td>
                  <td className="date">
                    {textSubStr(list.time)[0]}

                    <br />
                    {textSubStr(list.time)[1]}
                  </td>
                  <td>{list.type}</td>
                  <td>
                    {list.mup > 0 &&
                    (list.type == "사용" || list.type == "적립취소")
                      ? "-" + replaceCommas(list.mup)
                      : "+" + replaceCommas(list.mup)}
                    p
                  </td>
                </tr>
              ))} */}
          </tbody>
        </Table>
      )}
    </>
  );
};

export default PointHistory;
const Table = styled.table`
  font-size: 1.2rem;
  font-weight: 700;
  line-height: 1.2rem;
  width: 100%;
  text-align: left;
  .date {
    font-size: 1rem;
    line-height: 1rem;
    font-weight: 400;
  }
  thead {
    height: 4.2rem;
    border-bottom: 1px solid ${({ theme }) => theme.color.black};
    th {
      line-height: 4.2rem;
    }
  }
  tr {
    :nth-child(1) {
      padding-left: 1rem;
    }
    :nth-last-child(1) {
      text-align: right;
      padding-right: 1rem;
    }
  }
  tbody {
    tr {
      height: 5rem;
      border-bottom: 1px dotted #000;
    }
    :nth-last-child(1) {
      border-bottom: 0;
    }
  }
`;
